module.exports = __webpack_public_path__ + "img/CRockThrower64_ua.2175083a.webp";